import { render, staticRenderFns } from "./Datepicker-component.vue?vue&type=template&id=bc2a4d06"
import script from "./Datepicker-component.vue?vue&type=script&lang=js"
export * from "./Datepicker-component.vue?vue&type=script&lang=js"
import style0 from "./Datepicker-component.vue?vue&type=style&index=0&id=bc2a4d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports